import { dateToXAgo } from '@helpers/dateToXAgo';
import { useEffect, useState } from 'react';

type TProps = {
  date?: Date | string | number;
};

export const TickingDateAgo = ({ date }: TProps) => {
  const [value, setValue] = useState(dateToXAgo(date ?? 0));
  useEffect(() => {
    const now = Date.now();
    const diff = Math.floor((now - new Date(date ?? 0).getTime()) / 1000);
    let timeout = 1000;
    // More than 7 days ago
    if (diff > 7 * 24 * 60 * 60) {
      return;
    }
    // More than 1 day ago
    if (diff > 24 * 60 * 60) {
      timeout = 24 * 60 * 60 * 1000;
    }
    // More than hour ago
    if (diff > 60 * 60) {
      timeout = 60 * 60 * 1000;
    }
    // More than minute ago
    if (diff > 60) {
      timeout = 60 * 1000;
    }
    const interval = setInterval(() => setValue(dateToXAgo(date ?? 0)), timeout);
    return () => clearInterval(interval);
  }, []);

  return <span className="ticking-date-ago">{value}</span>;
};
